import { displayError } from '../helpers';
import { printGoodsReceiptNote } from '../services/GoodsReceiptNoteServices';
import { openPdfInApp } from './openPdfInApp';

async function parseApiError(error) {
    const responseData = error?.response?.data;
    if (responseData instanceof Blob) {
        try {
            const text = await responseData.text();
            try {
                return JSON.parse(text);
            } catch (parseError) {
                return { message: text || 'Failed to generate goods receipt note PDF.' };
            }
        } catch (readError) {
            return { message: 'Failed to generate goods receipt note PDF.' };
        }
    }
    return responseData || error;
}

export function fetchAndShowGrnPdf(cookies, grnId, options = {}) {
    return printGoodsReceiptNote(cookies, grnId)
        .then((pdfResponse) => {
            openPdfInApp(pdfResponse, {
                title: options.title || 'Goods Receipt Note',
                downloadFileName: options.downloadFileName || `GRN-${grnId}.pdf`,
                onClose: options.onClose,
            });
        })
        .catch(async (error) => {
            const parsedError = await parseApiError(error);
            displayError(
                parsedError || { message: 'Failed to generate goods receipt note PDF.' },
                options.errorTitle || 'Print Failed',
            );
        });
}
